export default __webpack_public_path__ + "static/media/payout-ng.637ec744.png";